module.exports = __webpack_public_path__ + "img/Ident-3-mobile.87e03442.png";